import React, { Component } from 'react';

class MfaEnableTextMessage extends Component {
    state = {  } 
    
    render() { 
        return <div>Enable The Email</div>;
    }
}
 
export {MfaEnableTextMessage}